import {createMuiTheme} from 'material-ui/styles';

export default (theme) => ({
    root: {
        width: '100%',
        zIndex: 1,
        overflow: 'hidden',
    },
    appFrame: {
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
    },
    content: {
        width: '100%',
        flexGrow: 1,
        backgroundColor: '#f4f4f4',
        padding: 24,
        marginTop: 56,
    },
    textImageUploading: {
        marginTop: '-19px',
        textAlign: 'center',
        position: 'relative',
        color: '#fff',
        fontWeight: 500,
        zIndex: 2,
    },
    paperImageUploading: {
        height: 20,
        position: 'fixed',
        width: '100%',
        top: 57,
        left: 0,
        [theme.breakpoints.up('sm')]: {
            top: 65,
        },
    },
});

export const theme = createMuiTheme({
    palette: {
        "primary": {
            "50": "#00ad78",
            "100": "#009c6c",
            "200": "#008b60",
            "300": "#007a55",
            "400": "#006949",
            "500": "#00583d",
            "600": "#004731",
            "700": "#003625",
            "800": "#00251a",
            "900": "#052509",
            "A100": "#b6edd3",
            "A200": "#4fd66e",
            "A400": "#1bba40",
            "A700": "#00895f",
            "contrastDefaultColor": "light",
        },
        "secondary": {
            "50": "#E3F2FD",
            "100": "#BBDEFB",
            "200": "#90CAF9",
            "300": "#64B5F6",
            "400": "#42A5F5",
            "500": "#2196F3",
            "600": "#1E88E5",
            "700": "#2979FF",
            "800": "#1565C0",
            "900": "#0D47A1",
            "A100": "#82B1FF",
            "A200": "#448AFF",
            "A400": "#1976D2",
            "A700": "#2962FF",
            "contrastDefaultColor": "dark",
          },
    }
});



// WEBPACK FOOTER //
// ./src/components/App.style.js